export default function Privacy() {
  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>NeighborUp Privacy Policy</h1>
      <p><em>Last updated: September 19, 2025</em></p>

      <p>
        NeighborUp respects your privacy and is committed to protecting your personal data.
        This Privacy Policy explains what information we collect, how we use it, and your rights regarding your information.
      </p>

      <h2>Information We Collect</h2>
      <ul>
        <li><strong>Account Information:</strong> Name, username, email, profile photo, and password-related data.</li>
        <li><strong>Location:</strong> Your current location to provide nearby NeighborUps and location-based features.</li>
        <li><strong>NeighborUp & Assist Data:</strong> Details about your participation in NeighborUp, responses to Assists, and distances/preferences.</li>
        <li><strong>Preferences & App Settings:</strong> Chats with other users and notes saved in Profile page.</li>
        <li><strong>Ratings:</strong> Your ratings and feedback given or received within the app.</li>
        <li><strong>Push Notifications:</strong> Expo Push Tokens to send alerts and notifications.</li>
      </ul>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>Provide app functionality, including matching users for NeighborUps.</li>
        <li>Send push notifications and updates.</li>
        <li>Improve app experience and provide support.</li>
      </ul>

      <h2>Sharing Your Information</h2>
      <p>
        We do not share your personal information with third parties except:
      </p>
      <ul>
        <li>When required by law.</li>
      </ul>

      <h2>Data Retention</h2>
      <p>
        We retain your data as long as necessary to provide services and comply with legal obligations. 
      </p>

      <h2>Your Rights</h2>
      <p>
        Depending on your location, you may have rights under applicable laws (e.g., GDPR or CCPA), including:
      </p>
      <ul>
        <li>Accessing and requesting a copy of your personal data.</li>
        <li>Requesting correction of inaccurate data.</li>
        <li>Requesting deletion of your data.</li>
      </ul>

      <h2>Contact Us</h2>
      <p>
        For questions about this Privacy Policy or your personal data, contact us at: <a href="mailto:cwantuch7@gmail.com">cwantuch7@gmail.com</a>
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. Changes will be communicated in-app and via email to the address associated with your account.
      </p>
    </div>
  );
}